import { useRef, useState, useEffect } from "react";
import { Play, Volume2, VolumeX } from "lucide-react";

export const HomeVideo = () => {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  const [muted, setMuted] = useState(true);
  const [canHover, setCanHover] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined" && window.matchMedia) {
      setCanHover(window.matchMedia("(hover: hover)").matches);
    }
  }, []);

  const startWithSound = () => {
    const v = ref.current;
    if (!v) return;
    setActive(true);
    setMuted(false);
    v.muted = false;
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };

  const onEnter = () => {
    if (canHover && !active) {
      const v = ref.current;
      if (v) { v.muted = true; v.play().catch(() => {}); }
    }
  };
  const onLeave = () => {
    if (canHover && !active) {
      const v = ref.current;
      if (v) v.pause();
    }
  };
  const onClick = () => { if (!active) startWithSound(); };

  const toggleMute = (e) => {
    e.stopPropagation();
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
  };

  const onEnded = () => {
    setActive(false);
    setMuted(true);
  };

  return (
    <div
      data-testid="home-video"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      onClick={onClick}
      className="group relative mx-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-[#222] bg-black glow-fuchsia cursor-pointer aspect-video"
    >
      <video
        ref={ref}
        poster="/videos/chien_3d_poster.jpg"
        playsInline
        preload="metadata"
        muted={muted}
        loop={!active}
        onEnded={onEnded}
        className="absolute inset-0 h-full w-full object-cover"
      >
        <source src="/videos/chien_3d.mp4" type="video/mp4" />
        <source src="/videos/chien_3d.webm" type="video/webm" />
      </video>

      {/* idle overlay: play button + hint */}
      {!active && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-t from-black/70 via-black/20 to-black/40 transition-opacity">
          <button
            type="button"
            data-testid="home-video-play"
            onClick={onClick}
            aria-label="Lire la vidéo avec le son"
            className="flex h-20 w-20 items-center justify-center rounded-full bg-[#E6007E] text-white shadow-lg transition-transform duration-300 group-hover:scale-110 active:scale-95"
          >
            <Play className="ml-1 h-9 w-9" fill="currentColor" />
          </button>
          <span className="mt-4 rounded-full bg-black/60 px-4 py-1.5 text-sm font-semibold text-white">
            {canHover ? "Cliquez pour lancer avec le son" : "Appuyez pour lire"}
          </span>
        </div>
      )}

      {/* sound toggle while playing */}
      {active && (
        <button
          type="button"
          data-testid="home-video-mute"
          onClick={toggleMute}
          aria-label={muted ? "Activer le son" : "Couper le son"}
          className="absolute bottom-4 right-4 flex h-11 w-11 items-center justify-center rounded-full bg-black/60 text-white backdrop-blur transition-colors hover:bg-[#E6007E]"
        >
          {muted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
        </button>
      )}
    </div>
  );
};

export default HomeVideo;
